import { useAtom, useAtomValue } from 'jotai'
import { modalStatusAtom, selectedAccountAtom } from 'store/atoms'

import CustomCardArt from '@card-actions/custom-card-art'
import { customCardArtModalContainerId } from 'const/modalContainerId'
import triggerAnalyticsEvent from 'helpers/triggerAnalyticsEvent'
import { MFEConfig } from 'syf-js-utilities/typings/mfeConfig'
import {
  AuthenticationRedirectProps,
  handleMFEAuthenticationRedirect
} from 'helpers/authenticationRedirect'
import routes from 'const/routes'
import getMFEConfig from 'helpers/getMFEConfig'
import { getBrandRefreshPhase } from 'helpers/getBrandRefreshPhase'
import isProductionEnv from 'helpers/isProductionEnv'
import { triggerOnCloseAnalytics } from 'helpers/triggerOnCloseAnalytics'

const CustomCardArtModal = () => {
  const [{ modalId }, updateModalStatus] = useAtom(modalStatusAtom)
  const selectedAccount = useAtomValue(selectedAccountAtom)
  const isModalOpen = modalId === 'CustomCardArt'

  const mfeConfig: MFEConfig = getMFEConfig('customCardArt')

  const handleCloseModal = () => {
    updateModalStatus('', '')
    triggerOnCloseAnalytics()
  }

  const handleAuthenticationRedirect = () => {
    const props: AuthenticationRedirectProps = {
      navigateTo: routes.HOME,
      modal: 'CustomCardArt',
      scope: 'read write write:sensitive'
    }

    handleMFEAuthenticationRedirect(props)
  }

  return (
    isModalOpen && (
      <CustomCardArt
        authenticationRedirect={handleAuthenticationRedirect}
        closeModal={handleCloseModal}
        containerId={customCardArtModalContainerId(selectedAccount)}
        envProp={isProductionEnv() ? 'production' : 'development'}
        featureFlags={{ brandRefreshPhase: getBrandRefreshPhase() }}
        isModalOpen={isModalOpen}
        mfeConfig={mfeConfig}
        selectedAccountId={selectedAccount}
        triggerAnalyticsEvent={triggerAnalyticsEvent}
      />
    )
  )
}

export default CustomCardArtModal
